import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError, map, startWith } from 'rxjs/operators';
import { ComponentMonitorResponse, GstarClient } from 'src/app/web-api-client';
import { MonitorRow } from '../models/monitor-row';

@Injectable({
  providedIn: 'root',
})
export class MonitorService {
  private readonly gstarClient = inject(GstarClient);
  private readonly translate = inject(TranslateService);

  getMonitorStatus: Observable<MonitorRow[]> = this.gstarClient.monitor().pipe(
    catchError(() => {
      return of([
        {
          success: false,
          component: [this.translate.instant('webApiMonitor.data.component')],
          alias: [this.translate.instant('webApiMonitor.data.alias')],
          details: [this.translate.instant('webApiMonitor.data.details')],
          status: [this.translate.instant('webApiMonitor.data.status')],
        } as unknown as ComponentMonitorResponse,
        {
          success: false,
          component: [this.translate.instant('gstarCentralDb.data.component')],
          alias: [this.translate.instant('gstarCentralDb.data.alias')],
          details: [this.translate.instant('gstarCentralDb.data.details')],
          status: [this.translate.instant('gstarCentralDb.data.status')],
        } as unknown as ComponentMonitorResponse,
      ]);
    }),
    map((response: ComponentMonitorResponse[]) => {
      return response?.map(
        row =>
          ({
            success: row?.success,
            component: row?.component,
            alias: row?.alias,
            details: row?.details,
            status: row?.status,
          }) as MonitorRow
      );
    }),
    startWith([])
  );
}
